<template>
  <div class="modal-dialog modal-xl">
    <div
      class="modal-content"
    >
      <div class="modal-header bg-dark">
        <h6 class="modal-title">
          {{ $t("Purchase Subscription Plan") }}
        </h6>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <div class="py-5 mb-5">
            <div class="mt-5 mb-3">
              <img
                src="@/assets/global_assets/images/thank_you.png"
                class=""
                alt=""
                style="width: 40%;"
              >
            </div>
            <h1 class="error-page-title text-dark">
              {{ $t('_Plan.Transaction Success') }}!
            </h1>
            <div class="error-page-text">
              <div>
                {{ $t('_Plan.Your order number is') }}
                <a href="#">{{ orderNumber }}.</a>
              </div>
              <div class="row">
                <div class="col-lg-4 mx-lg-auto">
                  <div
                    v-html="replaceText($t('Please wait for administrator to confirm your transaction or contact {Line} for questions.'))"
                  />
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button
                class="btn btn-lg btn-primary"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                ref="close"
                @click="close()"
              >
                <i class="fas fa-arrow-alt-circle-left mr-2" />
                {{ $t('Go Back') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    orderNumber:{
      type: String,
      default : ""
    },
  },
  computed: {
  },
  data() {
    return {
      };
  },
  watch: {
  },
  methods: {
    close(){
      this.$refs.close.click();
      this.$parent.isSelectAddress = false;
      this.$parent.showQrCode = false;
      this.$parent.loading = false;
      this.$parent.submitted_formDeposit = false;
      this.$parent.invalidCoupon = false;
      this.$parent.usedCoupon = false;
      this.$parent.couponCode = "";
      this.$parent.isClearCouponCode = false;
      this.$parent.isModalSuccess = false;
    },
    replaceText(text){
      let textBefore = text.replace('{Line}','<a href="https://lin.ee/youGgaO" target="_blank" > Line:@gosell</a>')
      return textBefore;
    },
  },
};
</script>

    <style scoped>
span.select-plan {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 18px 18px;
  border-color: transparent transparent #007bff transparent;
}

span.select-plan > i,
span.select-plan > span {
  position: absolute;
  right: 2px;
  top: 9px;
  font-size: 7px;
  color: #fff;
}

.bg-light-f6f6f6 {
  background-color: #f6f6f6 !important;
  color: inherit !important;
}

.step-num {
  height: 24px;
  width: 24px;
  font-weight: normal;
  text-align: center;
  padding: 0;
  line-height: 24px;
  background: #333;
  color: #fff;
  border-radius: 100%;
}

.table th {
  border-top: 0;
}

dl {
  display: flex;
  align-items: start;
  justify-content: space-between;
}

dl dt,
dl dd {
  margin-bottom: 0;
}

.searching {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  border-top-color: #888;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

span.select-coupon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 18px 18px;
  border-color: transparent transparent #007bff transparent;
}

span.select-coupon > i {
  position: absolute;
  right: 2px;
  top: 9px;
  font-size: 7px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/premium-subscriptions/payment-modal/ModalSuccess.vue